<template>
  <IconPickerInput :value="modelVal" @input="onSelect" />
</template>

<script>
import ncformCommon from "@ncform/ncform-common";
import IconPickerInput from "../IconPickerInput";

export default {
  name: "form-input-icon-picker",
  mixins: [ncformCommon.mixins.vue.controlMixin],
  props: ["value"],
  components: { IconPickerInput },
  methods: {
    onSelect(icon) {
      this.$emit("input", icon);
    },
    _processModelVal(modelVal) {
      return modelVal;
    },
  },
};
</script>
